import { useContext } from 'react';
import { PathContext } from '~/jobiqo/context/app';

interface UseJobPageMetaProps {
  isEditPage: boolean;
}

/**
 * It returns an object with a single property, isEditPage, which is true if the
 * current path is /job/edit/[id]
 * @returns A function that returns an object with a property called isEditPage.
 */
export default function useJobPageMeta(): UseJobPageMetaProps {
  const { pathname } = useContext(PathContext);
  return { isEditPage: pathname === '/job/edit/[id]' };
}
